export default __webpack_public_path__ + "static/media/sun_wt.16519697.jpg";